import axios from "axios";
import { emitDataChanged } from "@/lib/dataBus";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,   // sends the httpOnly `access_token` cookie
});

// Auth is carried entirely by the httpOnly cookie set on POST /auth/login.
// We deliberately do NOT read/write access_token from localStorage — that
// would defeat the point of the httpOnly cookie (any XSS could exfiltrate
// the token). `withCredentials: true` above tells axios to include the
// cookie on every same-origin & CORS request automatically.

// Iter 36.7 Phase 3 — Real-time sync. Any mutation on the API (POST / PATCH
// / PUT / DELETE) fires a global "data changed" event so every page /
// component that fetches users/projects/teams refetches immediately.
// GETs are excluded to avoid an infinite loop.
api.interceptors.response.use((res) => {
  try {
    const method = (res?.config?.method || "").toLowerCase();
    if (method && method !== "get") {
      // Tag the event with a coarse kind derived from the URL so subscribers
      // can filter (e.g. only refetch users on user-touching mutations).
      const url = res?.config?.url || "";
      let kind = "any";
      if (url.includes("/users") || url.includes("/auth/register")) kind = "users";
      else if (url.includes("/projects")) kind = "projects";
      else if (url.includes("/seo") || url.includes("/marketing")) kind = "seo";
      else if (url.includes("/sidebar-lists") || url.includes("/shares")) kind = "sidebar";
      emitDataChanged(kind);
    }
  } catch (e) { /* silent */ }
  return res;
});

export default api;

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e.msg || JSON.stringify(e)).join(", ");
  return String(d);
}
